(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-support-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('navee-contact-support-carousel')) {
    class ContactSupportCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-contact-track]');
        this.pagination = this.querySelector('[data-contact-pagination]');
        this.items = Array.from(this.querySelectorAll('.navee-contact-support__item'));
        this.perPage = Number(this.dataset.itemsPerPage) || 2;
        this.sliderEnabled = this.dataset.sliderEnabled === 'true';
        this.mobileMedia = window.matchMedia('(max-width: 749px)');

        if (!this.track || !this.pagination || !this.sliderEnabled) return;

        this.handleScroll = this.updateActiveDot.bind(this);
        this.handleResize = this.setupPagination.bind(this);
        this.handleBlockSelect = this.onBlockSelect.bind(this);

        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);

        this.setupPagination();
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.track.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      setupPagination() {
        if (!this.mobileMedia.matches) {
          this.pagination.hidden = true;
          return;
        }

        const pageCount = Math.ceil(this.items.length / this.perPage);
        this.pagination.replaceChildren();

        if (pageCount <= 1) {
          this.pagination.hidden = true;
          return;
        }

        this.pagination.hidden = false;

        for (let page = 0; page < pageCount; page += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'navee-contact-support__dot';
          dot.setAttribute('aria-label', `${this.dataset.pageLabel} ${page + 1}`);
          dot.setAttribute('aria-current', page === 0 ? 'true' : 'false');
          dot.addEventListener('click', () => this.goToPage(page));
          this.pagination.appendChild(dot);
        }

        this.updateActiveDot();
      }

      goToPage(page) {
        const target = this.items[page * this.perPage];
        if (!target) return;
        this.track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }

      updateActiveDot() {
        if (this.pagination.hidden) return;

        const pageTargets = this.items.filter((item, index) => index % this.perPage === 0);
        let activePage = 0;
        let smallestDistance = Number.POSITIVE_INFINITY;

        pageTargets.forEach((item, index) => {
          const distance = Math.abs(item.offsetLeft - this.track.scrollLeft);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            activePage = index;
          }
        });

        Array.from(this.pagination.children).forEach((dot, index) => {
          dot.setAttribute('aria-current', index === activePage ? 'true' : 'false');
        });
      }

      onBlockSelect(event) {
        if (!this.mobileMedia.matches) return;
        const selectedItem = event.target.closest('.navee-contact-support__item');
        if (!selectedItem || !this.contains(selectedItem)) return;
        const itemIndex = this.items.indexOf(selectedItem);
        this.goToPage(Math.floor(itemIndex / this.perPage));
      }
    }

    customElements.define('navee-contact-support-carousel', ContactSupportCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spare-part"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spare-part-coverflow')) {
    customElements.define(
      'spare-part-coverflow',
      class SparePartCoverflow extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.cards = Array.from(this.querySelectorAll('[data-coverflow-card]'));
          this.dots = Array.from(this.querySelectorAll('[data-coverflow-dot]'));
          this.stage = this.querySelector('.spare-part__stage');
          this.mobileTrack = this.querySelector('.spare-part__mobile-streams');
          this.mobileCards = Array.from(this.querySelectorAll('.spare-part__mobile-card'));
          this.activeIndex = Math.min(
            Math.max(Number.parseInt(this.dataset.startIndex, 10) || 0, 0),
            Math.max(this.cards.length - 1, 0)
          );
          this.autoplay = this.dataset.autoplay === 'true';
          this.mobileAutoplay = this.dataset.mobileAutoplay === 'true';
          this.pauseOnHover = this.dataset.pauseOnHover === 'true';
          this.delay = Math.max(Number.parseInt(this.dataset.delay, 10) || 4, 2) * 1000;
          this.mobileSpeed = Math.max(Number.parseInt(this.dataset.mobileSpeed, 10) || 25, 5);
          this.mobileAnimationFrame = null;
          this.mobileLastTimestamp = 0;
          this.mobileLoopWidth = 0;
          this.pointerStartX = 0;
          this.pointerDeltaX = 0;
          this.dragged = false;
          this.mobileMedia = window.matchMedia('(max-width: 749px)');

          this.onKeydown = this.handleKeydown.bind(this);
          this.onPointerDown = this.handlePointerDown.bind(this);
          this.onPointerMove = this.handlePointerMove.bind(this);
          this.onPointerUp = this.handlePointerUp.bind(this);
          this.onCardClick = this.handleCardClick.bind(this);
          this.onDotClick = this.handleDotClick.bind(this);
          this.onPause = this.stopTimer.bind(this);
          this.onResume = this.startTimer.bind(this);
          this.onBlockSelect = this.handleBlockSelect.bind(this);
          this.onMediaChange = this.handleMediaChange.bind(this);
          this.onMobilePause = this.pauseMobile.bind(this);
          this.onMobileResume = this.resumeMobile.bind(this);
          this.onMobileAnimationFrame = this.animateMobile.bind(this);
          this.onWindowResize = this.handleWindowResize.bind(this);

          this.stage.addEventListener('keydown', this.onKeydown);
          this.stage.addEventListener('pointerdown', this.onPointerDown);
          this.stage.addEventListener('pointermove', this.onPointerMove);
          this.stage.addEventListener('pointerup', this.onPointerUp);
          this.stage.addEventListener('pointercancel', this.onPointerUp);
          this.stage.addEventListener('click', this.onCardClick);
          this.addEventListener('click', this.onDotClick);
          this.addEventListener('shopify:block:select', this.onBlockSelect);
          this.mobileMedia.addEventListener('change', this.onMediaChange);
          window.addEventListener('resize', this.onWindowResize);

          if (this.mobileTrack) {
            this.mobileTrack.addEventListener('pointerdown', this.onMobilePause);
            this.mobileTrack.addEventListener('pointerup', this.onMobileResume);
            this.mobileTrack.addEventListener('pointercancel', this.onMobileResume);
            this.mobileTrack.addEventListener('pointerenter', this.onMobilePause);
            this.mobileTrack.addEventListener('pointerleave', this.onMobileResume);
            this.mobileTrack.addEventListener('focusin', this.onMobilePause);
            this.mobileTrack.addEventListener('focusout', this.onMobileResume);
          }

          if (this.pauseOnHover) {
            this.addEventListener('pointerenter', this.onPause);
            this.addEventListener('pointerleave', this.onResume);
            this.addEventListener('focusin', this.onPause);
            this.addEventListener('focusout', this.onResume);
          }

          this.prepareMobileLoop();
          this.update();
          this.startTimer();
          window.requestAnimationFrame(() => this.startMobileAnimation());
        }

        disconnectedCallback() {
          this.stopTimer();
          this.stopMobileAnimation();
          this.mobileMedia.removeEventListener('change', this.onMediaChange);
          window.removeEventListener('resize', this.onWindowResize);
        }

        normalizedPosition(index) {
          const count = this.cards.length;
          let position = index - this.activeIndex;
          const halfway = count / 2;

          if (position > halfway) position -= count;
          if (position < -halfway) position += count;

          return position;
        }

        update() {
          this.cards.forEach((card, index) => {
            const position = this.normalizedPosition(index);
            const visible = Math.abs(position) <= 2;
            const active = position === 0;
            const link = card.querySelector('a');

            card.dataset.position = visible ? String(position) : 'hidden';
            card.setAttribute('aria-hidden', visible ? 'false' : 'true');

            if (link) {
              link.tabIndex = active ? 0 : -1;
            }
          });

          this.dots.forEach((dot, index) => {
            if (index === this.activeIndex) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        }

        goTo(index) {
          if (this.cards.length < 2) return;
          this.activeIndex = (index + this.cards.length) % this.cards.length;
          this.update();
        }

        next() {
          this.goTo(this.activeIndex + 1);
        }

        previous() {
          this.goTo(this.activeIndex - 1);
        }

        prepareMobileLoop() {
          if (!this.mobileTrack || this.mobileCards.length < 2) return;
          if (this.mobileTrack.dataset.loopReady === 'true') return;

          this.mobileTrack.dataset.loopReady = 'true';
          this.mobileClones = this.mobileCards.map((card) => {
            const clone = card.cloneNode(true);
            clone.classList.add('spare-part__mobile-card--clone');
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('data-shopify-editor-block');
            clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
              element.removeAttribute('data-shopify-editor-block');
            });
            clone.querySelectorAll('a, button, [tabindex]').forEach((element) => {
              element.tabIndex = -1;
            });
            this.mobileTrack.appendChild(clone);
            return clone;
          });
        }

        refreshMobileLoopWidth() {
          if (!this.mobileTrack || !this.mobileClones || !this.mobileClones.length) return;
          this.mobileLoopWidth = this.mobileClones[0].offsetLeft - this.mobileCards[0].offsetLeft;

          if (this.mobileLoopWidth > 0 && this.mobileTrack.scrollLeft >= this.mobileLoopWidth) {
            this.mobileTrack.scrollLeft %= this.mobileLoopWidth;
          }
        }

        animateMobile(timestamp) {
          if (!this.mobileMedia.matches || !this.mobileAutoplay || !this.mobileTrack) return;

          if (!this.mobileLastTimestamp) this.mobileLastTimestamp = timestamp;
          const elapsed = Math.min((timestamp - this.mobileLastTimestamp) / 1000, 0.064);
          this.mobileLastTimestamp = timestamp;
          this.mobileTrack.scrollLeft += this.mobileSpeed * elapsed;

          if (this.mobileLoopWidth > 0 && this.mobileTrack.scrollLeft >= this.mobileLoopWidth) {
            this.mobileTrack.scrollLeft -= this.mobileLoopWidth;
          }

          this.mobileAnimationFrame = window.requestAnimationFrame(this.onMobileAnimationFrame);
        }

        startMobileAnimation() {
          this.stopMobileAnimation();
          if (!this.mobileMedia.matches || !this.mobileAutoplay) return;
          if (!this.mobileTrack || this.mobileCards.length < 2) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.refreshMobileLoopWidth();
          if (this.mobileLoopWidth <= 0) return;
          this.mobileLastTimestamp = 0;
          this.mobileAnimationFrame = window.requestAnimationFrame(this.onMobileAnimationFrame);
        }

        stopMobileAnimation() {
          if (this.mobileAnimationFrame) {
            window.cancelAnimationFrame(this.mobileAnimationFrame);
            this.mobileAnimationFrame = null;
          }
          this.mobileLastTimestamp = 0;
        }

        pauseMobile() {
          this.stopMobileAnimation();
        }

        resumeMobile() {
          this.startMobileAnimation();
        }

        handleWindowResize() {
          this.refreshMobileLoopWidth();
        }

        startTimer() {
          this.stopTimer();
          if (this.mobileMedia.matches) return;
          if (!this.autoplay) return;
          if (this.cards.length < 2) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (this.pauseOnHover && this.matches(':hover')) return;
          if (this.pauseOnHover && this.contains(document.activeElement)) return;
          this.timer = window.setInterval(() => this.next(), this.delay);
        }

        stopTimer() {
          if (this.timer) {
            window.clearInterval(this.timer);
            this.timer = null;
          }
        }

        handleMediaChange() {
          this.update();
          this.startTimer();
          this.startMobileAnimation();
        }

        handleKeydown(event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.previous();
            this.startTimer();
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.next();
            this.startTimer();
          }
        }

        handlePointerDown(event) {
          this.pointerStartX = event.clientX;
          this.pointerDeltaX = 0;
          this.dragged = false;
          this.stopTimer();

          if (this.stage.setPointerCapture) {
            this.stage.setPointerCapture(event.pointerId);
          }
        }

        handlePointerMove(event) {
          this.pointerDeltaX = event.clientX - this.pointerStartX;
          if (Math.abs(this.pointerDeltaX) > 8) this.dragged = true;
        }

        handlePointerUp() {
          if (Math.abs(this.pointerDeltaX) > 42) {
            if (this.pointerDeltaX < 0) {
              this.next();
            } else {
              this.previous();
            }
          }

          window.setTimeout(() => {
            this.dragged = false;
          }, 0);

          this.startTimer();
        }

        handleCardClick(event) {
          const card = event.target.closest('[data-coverflow-card]');
          if (!card) return;

          const index = Number.parseInt(card.dataset.cardIndex, 10);
          const position = this.normalizedPosition(index);

          if (this.dragged || position !== 0) {
            event.preventDefault();
          }

          if (!this.dragged && position !== 0) {
            this.goTo(index);
            this.startTimer();
          }
        }

        handleDotClick(event) {
          const dot = event.target.closest('[data-coverflow-dot]');
          if (!dot) return;
          this.goTo(Number.parseInt(dot.dataset.dotIndex, 10));
          this.startTimer();
        }

        handleBlockSelect(event) {
          const card = event.target.closest('[data-coverflow-card]');
          if (!card) return;
          this.stopTimer();
          this.goTo(Number.parseInt(card.dataset.cardIndex, 10));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
